<template>
    <div class="detail">
        <!-- 1. 顶部标题栏 -->
        <detail-title-bar></detail-title-bar>

        <div class="detail-content">
            <!-- 3.4. 关系 -->
            <detail-relation v-bind:allList="allList" v-bind:relationList="detailRelationList[0]" class="layout-detail-relation-up" v-show="showDetailType == 3"></detail-relation>

            <!-- 2. 命盘 -->
            <fate-panel 
                v-bind:hideSideBar="false" 
                v-bind:fateData="detailFateListData" 
                v-bind:fateSideData="detailFateSideListData" 
                v-bind:fateInfo="detailFateInfo"
                v-bind:sideCloseFunc="clickSideClose">
            </fate-panel>
            <div class="layout-df-side">
                <span v-show="personInfo.location != ''" class="layout-df-side-span" @click="clickRealSunTime">真</span>
            </div>
            
            <!-- 3.1. 资料 -->
            <detail-infomation v-show="showDetailType == 0"></detail-infomation>

            <!-- 3.2. 运盘 -->
            <fortune-panel 
                v-show="showDetailType == 1"
                v-bind:detailInfo="personInfo"
                v-bind:fortuneTitle="detailFortuneTitle"
                v-bind:fortuneData="detailFortuneData"
                v-bind:transitioned="true"
                v-bind:parentFrom="'detail'"
                v-bind:subTitle="detailSubTitle"
                v-bind:showType="detailShowType"
                v-bind:showLabel="detailShowLabel"
                v-bind:showTitle="detailShowTitle"
                v-bind:showTable="detailShowTable"
                v-bind:liunianData="detailLiunianData"
                v-bind:liuyueData="detailLiuyueData"
                v-bind:liuriData="detailLiuriData"
                v-bind:liushiData="detailLiushiData"
                v-bind:labelFunc="clickFortuneLabel"
                v-bind:toggleFunc="clickFortuneToggleTable"
                v-bind:itemFunc="clickFortuneItem">
            </fortune-panel>

            <!-- 3.3. 神煞 -->
            <detail-shensha v-show="showDetailType == 2"></detail-shensha>

            <!-- 3.4. 关系 -->
            <detail-relation v-bind:allList="allList" v-bind:relationList="detailRelationList[1]" class="layout-detail-relation-down" v-show="showDetailType == 3"></detail-relation>
        </div>

        <!-- 4. 底部导航栏 -->
        <detail-bottom-bar></detail-bottom-bar>

        <!-- 5. 二维码弹框 -->
        <div class="layout-overlay" v-if="showQrCodePop"></div>
        <div class="layout-popup detail-qrcode-pop" v-if="showQrCodePop">
            <qrcode class="qrcode-img" id='qrImg' tag="img" :options="{size: 300}" :value="qrCodeValue" ></qrcode>
            <i class="iconbg icon-qr-logo qrcode-icon"></i>
            <i class="iconfont icon-close qrcode-close" @click="clickCloseQrCode"></i>
        </div>

        <!-- 6. 说明弹框 -->
        <div class="layout-overlay" v-if="showRealSunTimePop" @click="clickRealSunTimeOverLay"></div>
        <div class="layout-popup detail-note-pop" v-if="showRealSunTimePop">
            <div class="detail-note-pop-title">
                <i class="iconfont icon-arrowflower-left detail-note-pop-icon"></i>
                <span>真太阳时说明</span>
                <i class="iconfont icon-arrowflower-right detail-note-pop-icon"></i>
            </div>
            <div class="detail-note-pop-content">
                <p>就是不同地点根据太阳位置计算出来的地方时间，相当于古人使用日晷测出的当地时间。</p>
                <p>古代测算八字都是严格以当地时间为准，而现代因为大家统一使用北京时间，实际与北京经度偏差越大的地方时辰偏差越大。</p>
                <p class="p-green">为了精准测算八字，大家尽量使用真太阳时，确定好命主的出生地点。</p>
            </div>
        </div>

        <!-- 7. 操作批盘论盘弹框 -->
        <div class="layout-overlay layout-overlay-blank" v-if="showPipanLunpanPop" @click="clickPiLunOverLay"></div>
        <detail-pi-lun-pop v-if="showPipanLunpanPop"></detail-pi-lun-pop>

        <!-- 8. 提示打开分享弹框 -->
        <div class="layout-overlay" v-if="showDetailSharePop" @click="clickShareOverlay"></div>
        <detail-share-pop v-if="showDetailSharePop"></detail-share-pop>

        <router-view></router-view>
    </div>
</template>

<script>
import DetailTitleBar from '../layouts/detail/DetailTitleBar.vue'
import FatePanel from '../layouts/panel/FatePanel.vue'
import FortunePanel from '../layouts/panel/FortunePanel.vue'
import DetailInfomation from '../layouts/detail/DetailInfomation.vue'
import DetailShensha from '../layouts/detail/DetailShensha.vue'
import DetailRelation from '../layouts/detail/DetailRelation.vue'
import DetailBottomBar from '../layouts/detail/DetailBottomBar.vue'
import DetailPiLunPop from '../layouts/detail/DetailPiLunPop.vue'
import DetailSharePop from '../layouts/detail/DetailSharePop.vue'
export default {
    name: 'Detail',
    components: { DetailTitleBar, FatePanel, FortunePanel, DetailInfomation, DetailShensha, DetailRelation, DetailBottomBar, DetailPiLunPop, DetailSharePop },
    computed: {
        personInfo() {
            return this.$store.state.detail.personInfo
        },
        detailFateInfo(){
            return this.$store.state.detail.fatefortune.fateInfo
        },
        detailFateListData(){
            return this.$store.state.detail.fatefortune.fateListData
        },
        detailFateSideListData(){
            return this.$store.state.detail.fatefortune.fateSideListData
        },
        allList() {
            return this.$store.state.detail.fatefortune.fateListData.concat(this.$store.state.detail.fatefortune.fateSideListData)
        },
        detailFortuneTitle() {
            return this.$store.state.detail.fatefortune.fortuneTitle;
        },
        detailFortuneData() {
            return this.$store.state.detail.fatefortune.fortuneListData;
        },
        detailSubTitle() {
            return this.$store.state.detail.fatefortune.subTitle
        },
        detailShowLabel() {
            return this.$store.state.detail.fatefortune.showLabel
        },
        detailShowTitle() {
            return this.$store.state.detail.fatefortune.showTitle;
        },
        detailShowTable() {
            return this.$store.state.detail.fatefortune.showTable;
        },
        detailShowType() {
            return this.$store.state.detail.fatefortune.showType;
        },
        detailLiunianData() {
            return this.$store.state.detail.fatefortune.liunianListData;
        },
        detailLiuyueData() {
            return this.$store.state.detail.fatefortune.liuyueListData;
        },
        detailLiuriData() {
            return this.$store.state.detail.fatefortune.liuriListData;
        },
        detailLiushiData() {
            return this.$store.state.detail.fatefortune.liushiListData;
        },
        detailRelationList(){
            return this.$store.state.detail.detailRelationList
        },
        showDetailType() {
            return this.$store.state.detail.showDetailType
        },
        showQrCodePop() {
            return this.$store.state.detail.showQrCodePop
        },
        qrCodeValue() {
            return this.$store.state.detail.qrCodeValue
        },
        showPipanLunpanPop() {
            return this.$store.state.detail.showPipanLunpanPop
        },
        showDetailSharePop() {
            return this.$store.state.detail.showDetailSharePop
        }
    },
    data(){
        return {
            clickLock: false,
            showRealSunTimePop: false
        }
    },
    beforeCreate: function() {
        // 滚动设置到初始值
        // document.documentElement.scrollTop = 0;
        // 容错处理
        if(location.pathname.indexOf('share') == -1 && !this.$store.state.detail.personInfo.id){
            this.$router.replace('/record');
        }
    },
    mounted: function() {
        var me = this,
            curPath = this.$router.history.current.path;
        setTimeout(() => {
            me.initDom();
        }, 20);
        setTimeout(() => {
            if(curPath.indexOf('share/detail') != -1) {
                this.$store.dispatch('reminder/checkShareExtTime');
            }else {
                this.$store.dispatch('reminder/checkDetailExtTime');
            }
        }, 2000);
    },
    methods:{
        initDom() {
            var titleDiv = document.getElementsByClassName("title-bar")[0];
            var contentDiv = document.getElementsByClassName("detail-content")[0];
            // 做一层容错
            if(contentDiv){
                contentDiv.style.height = (innerHeight - titleDiv.clientHeight) + 'px';
                // contentDiv.style.paddingTop = titleDiv.clientHeight + 'px';
            }
            
            // 解决输入框滚动之后，需要手动滚动的问题；
            var detailDiv = document.getElementsByClassName('detail')[0];
            if(detailDiv){
                detailDiv.scrollIntoView();
            }

            // 屏幕改变大小:旋转屏幕:重置高度
            window.onresize = function(){
                setTimeout(() => {
                    var contentDiv = document.getElementsByClassName("detail-content")[0];
                    if(contentDiv) {
                        contentDiv.style = 'height:' + (window.innerHeight - 55) + 'px';
                    }
                }, 20);
            }
            window.onorientationchange = function() {
                setTimeout(() => {
                    var contentDiv = document.getElementsByClassName("detail-content")[0];
                    if(contentDiv) {
                        contentDiv.style = 'height:' + (window.innerHeight - 55) + 'px';
                    }
                }, 20);
            }
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
                setTimeout(() => {
                    var contentDiv = document.getElementsByClassName("detail-content")[0];
                    if(contentDiv) {
                        contentDiv.style = 'height:' + (window.innerHeight - 55) + 'px';
                    }
                }, 20);
            }, false);

            // 禁止滚动
            // contentDiv.addEventListener("touchmove", function(e){
            //     e.preventDefault()
            // }, false);
        },
        clickCloseQrCode() {
            this.$store.state.detail.showQrCodePop = false;
        },
        clickRealSunTime() {
            this.showRealSunTimePop = true;
        },
        clickRealSunTimeOverLay() {
            this.showRealSunTimePop = false;
        },
        clickSideClose(data) {
            this.$store.dispatch("detail/fatefortune/deleteDetailFateSide", data);

            // 处理合化冲数据
            if(this.$store.state.detail.showDetailType == 3) {
                this.$store.dispatch('detail/initDetailHehuachong');
            }
        },
        clickFortuneLabel() {
            var me = this;
            var curPath = this.$router.history.current.path;
            console.log('clickFortuneLabel-----', curPath, this.personInfo.label)
            this.$store.dispatch('label/resetSelectedData');
            this.$store.dispatch('label/initLabelList', {
                cb: function() {
                    me.$store.dispatch('label/initSelectedLabelFromDetail', me.personInfo);
                    setTimeout(() => {
                        me.$router.replace(curPath + '/label');
                    }, 20);
                }
            });
        },
        clickFortuneToggleTable() {
            var showTable = this.$store.state.detail.fatefortune.showTable;
            this.$store.state.detail.fatefortune.showTable = showTable == 5 ? 10 : 5;
            this.$store.dispatch('detail/fatefortune/checkDetailFortuneData')
        },
        clickFortuneItem(data) {
            // 增加点击时间的锁定
            if(this.clickLock) {
                return;
            }
            var me = this;
            setTimeout(() => {
                me.clickLock = false;
            }, 300);
            this.clickLock = true;

            // 增加命盘右侧数据
            this.$store.dispatch("detail/fatefortune/addDetailFateSide", data);
            switch (data.type) {
                case "dayun":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuNian", data);
                    break;
                case "liunian":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuYue", data.year);
                    break;
                case "liuyue":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuRi", data.time);
                    break;
                case "liuri":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuShi", data.g);
                    break;
                default:
                    break;
            }
        },
        clickPiLunOverLay() {
            this.$store.state.detail.showPipanLunpanPop = false;
        },
        clickShareOverlay() {
            this.$store.state.detail.showDetailSharePop = false;
        },
        clickRemiderOverlay() {
            console.log('clickRemiderOverlay');
            // this.$store.state.reminder.clickRemiderOverlay = false;
        }
    }
}
</script>